'use strict';
import angular from 'angular';

angular.module('tieredLookups.services', [])

    .factory('TieredLookupsService', ['IORestangular', '$q', function (IORestangular, $q) {
        var tiers = IORestangular.all('tiers/types');
        var tier = IORestangular.all('tiers/type');
        var tierContents = IORestangular.all('tiers/contents');
        var tierContent = IORestangular.all('tiers/content');

        var getTieredLookups = function () {
            return tiers.customGET();
        };

        var addTieredLookup = function (lookupObj) {
            return tier.customPOST(lookupObj, undefined, undefined, undefined);
        }

        var updateTieredLookup = function (lookupObj) {
            return tier.customPUT(undefined, undefined, lookupObj, undefined);
        };

        var deleteTieredLookup = function (lookupObj) {
            return tier.remove(lookupObj);
        };

        var getTieredLookupContents = function (obj) {
            return tierContents.customGET(undefined, obj, undefined, undefined);
        };

        var getTieredLookupContent = function (lookupContentObj) {
            return tierContent.customGET(lookupContentObj, undefined, undefined, undefined);
        };

        var addTieredLookupContent = function (lookupContentObj) {
            return tierContent.customPOST(lookupContentObj, undefined, undefined, undefined);
        }

        var updateTieredLookupContent = function (lookupContentObj) {
            return tierContent.customPUT(undefined, undefined, lookupContentObj, undefined);
        };

        var deleteTieredLookupContent = function (lookupContentObj) {
            return tierContent.remove(lookupContentObj);
        };

        return {
            getTieredLookups: getTieredLookups,
            addTieredLookup: addTieredLookup,
            updateTieredLookup: updateTieredLookup,
            deleteTieredLookup: deleteTieredLookup,
            getTieredLookupContents: getTieredLookupContents,
            getTieredLookupContent: getTieredLookupContent,
            addTieredLookupContent: addTieredLookupContent,
            updateTieredLookupContent: updateTieredLookupContent,
            deleteTieredLookupContent: deleteTieredLookupContent
        };
    }]);